import api from "../libs/api";

const taskAutoService = {
	// getTasks: (page = 1, itemsPerPage = 10) => {
	//   return new Promise((resolve, reject) => {
	//     api()
	//       .get(`/auto-assign-tasks`, {
	//         params: {
	//           page,
	//           per_page: itemsPerPage,
	//         },
	//       })
	//       .then(({ status, data }) => {
	//         if (status === 200 || status === 200) resolve(data);
	//         throw new Error(`Failed with status: ${status}`);
	//       })
	//       .catch((error) => reject(error));
	//   });
	// },

	getTasks: (
		page = 1,
		itemsPerPage = 10,
		sortBy = "",
		order = "",
		filters = {}
	) => {
		return new Promise((resolve, reject) => {
			api()
				.get(`/auto-assign-tasks`, {
					params: {
						page,
						per_page: itemsPerPage,
						sort_by: sortBy,
						order: order,
						...filters,
					},
				})
				.then(({ status, data }) => {
					if (status === 200 || status === 201) resolve(data);
					else throw new Error(`Failed with status: ${status}`);
				})
				.catch((error) => reject(error));
		});
	},

	getTaskById: (id) => {
		return new Promise((resolve, reject) => {
			api()
				.get(`/assign-tasks/${id}`)
				.then(({ status, data }) => {
					if (status === 200 || status === 200) resolve(data.data);
					throw new Error(`Failed with status: ${status}`);
				})
				.catch((error) => reject(error));
		});
	},

	postTask: (data) => {
		return new Promise((resolve, reject) => {
			api()
				.post(`/auto-assign-tasks`, data)
				.then(({ status, data }) => {
					if (status === 200 || status === 201) resolve(data);
					throw new Error(`Failed with status: ${status}`);
				})
				.catch((error) => reject(error));
		});
	},

	getExistingMembers: (id) => {
		return new Promise((resolve, reject) => {
			api()
				.get(`/assign-tasks/${id}`)
				.then(({ status, data }) => {
					if (status === 200 || status === 200) resolve(data.data);
					throw new Error(`Failed with status: ${status}`);
				})
				.catch((error) => reject(error));
		});
	},

	updateTask: (id, data) => {
		return new Promise((resolve, reject) => {
			api()
				.put(`/auto-assign-tasks/${id}`, data)
				.then(({ status, data }) => {
					if (status === 201 || status === 200) resolve(data);
					throw new Error(`Failed with status: ${status}`);
				})
				.catch((error) => reject(error));
		});
	},

	deleteTask: (id) => {
		return new Promise((resolve, reject) => {
			api()
				.delete(`/auto-assign-tasks/${id}`)
				.then(({ status }) => {
					if (status === 204) resolve({ success: true });
					throw new Error(`Failed with status: ${status}`);
				})
				.catch((error) => reject(error));
		});
	},

	updateTaskStatus: (data) => {
		console.log(data);
		return new Promise((resolve, reject) => {
			api()
				.put(`/update-task-status`, data)
				.then(({ status, data }) => {
					if (status === 201) resolve(data);
					throw new Error(`Failed with status: ${status}`);
				})
				.catch((error) => reject(error));
		});
	},

	getTaskStatus: () => {
		return new Promise((resolve, reject) => {
			api()
				.get(`/task-status-names`)
				.then(({ status, data }) => {
					if (status === 200 || status === 200) resolve(data);
					throw new Error(`Failed with status: ${status}`);
				})
				.catch((error) => reject(error));
		});
	},
};

export default taskAutoService;
